import { Injectable, Signal, Type, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnumerationTypeDto } from '@digiwall/core/proxy';
import {
  PlanningDataSource,
  PlanningItemDto,
  ServiceWorkOrderStepPlanningService,
} from '@digiwall/goliath-documents/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { BasePlanningAdapter } from '../base-planning.adapter';
import { PlanningDataSourceAdapter } from '../planning-adapter';
import { ServiceWorkOrderStepBoardFilterComponent } from './service-work-order-step-board-filter.component';
import { ServiceWorkOrderStepPlanningCardComponent } from './service-work-order-step-planning-card.component';
import {
  SERVICE_WORK_ORDER_STEP_CARD_FIELDS,
  ServiceWorkOrderStepPlanningItemFieldsDto,
} from './service-work-order-step-planning-item-fields';
import { PlanningCardFieldDescriptor } from '../planning-card-field';

/** Planning adapter for ServiceWorkOrder steps (WorkOrderStepLine). */
@Injectable({ providedIn: 'root' })
export class ServiceWorkOrderStepPlanningAdapter
  extends BasePlanningAdapter
  implements PlanningDataSourceAdapter
{
  private readonly router = inject(Router);
  private readonly store = inject(GoliathDocumentsEnumerationTypeStore);

  readonly dataSource = PlanningDataSource.ServiceWorkOrderStep;
  readonly cardComponent: Type<unknown> = ServiceWorkOrderStepPlanningCardComponent;
  readonly boardFilterComponent: Type<unknown> = ServiceWorkOrderStepBoardFilterComponent;
  readonly statusEnumeration: Signal<EnumerationTypeDto[]> = this.store.workOrderStatus;
  readonly cardFields: PlanningCardFieldDescriptor[] = SERVICE_WORK_ORDER_STEP_CARD_FIELDS;

  constructor() {
    super(inject(ServiceWorkOrderStepPlanningService));
  }

  searchText(dto: PlanningItemDto): string {
    const fields = (dto.displayFields ?? {}) as ServiceWorkOrderStepPlanningItemFieldsDto;
    return [
      fields.displayNumber,
      fields.customer,
      fields.stepName,
      fields.equipment,
      fields.worker,
      fields.responsible,
      fields.article,
      fields.articleSerial,
    ]
      .filter(Boolean)
      .join(' ');
  }

  openItem(dto: PlanningItemDto): void {
    // The item id is the step-line id, so deep-link to the owning work order carried in displayFields.
    const fields = (dto.displayFields ?? {}) as ServiceWorkOrderStepPlanningItemFieldsDto;
    if (!fields.serviceWorkOrderId) {
      return;
    }
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/',
        'service-work-order',
        'service-work-orders',
        fields.serviceWorkOrderId,
      ]),
    );
    window.open(url, '_blank');
  }
}
